import { Component, OnInit } from '@angular/core';
import { UserStateService } from '../../auth/user-state-service';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'consolidated-risk-score',
    templateUrl: './consolidated-risk-score.component.html',
    styleUrls: ['./consolidated-risk-score.component.scss']
})
export class ConsolidatedRiskScoreComponent implements OnInit {

    breadCrumbs = ["Home", "Accounts", "Settings"];
    accountId: number;

    constructor(
        public userStateService: UserStateService,
        private readonly route: ActivatedRoute,
    ) {}

    ngOnInit() {
        this.accountId = +this.route.snapshot.paramMap.get("accountId");
    }

    get componentName() {
        return this.constructor.name;
    }
}
